/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Action for logging
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.1
 * @since 1.1.1
 */

import { createAction } from '../app/createAction';
import { LOG_BUSINESS_EVENT, LOG_BUSINESS_EVENT_FAILED, LOG_BUSINESS_EVENT_SUCCESS } from './loggingConstants';
import {
    ILogBusinessEvent,
    ILogBusinessEventFailed,
    ILogBusinessEventPayload,
    ILogBusinessEventSuccess,
} from './loggingTypes';

export const logBusinessEvent = (payload: ILogBusinessEventPayload): ILogBusinessEvent =>
    createAction(LOG_BUSINESS_EVENT, payload);

export const logBusinessEventSuccess = (): ILogBusinessEventSuccess =>
    createAction(LOG_BUSINESS_EVENT_SUCCESS);

export const logBusinessEventFailed = (): ILogBusinessEventFailed =>
    createAction(LOG_BUSINESS_EVENT_FAILED);

export type ILoggingActionTypes = ILogBusinessEvent
    | ILogBusinessEventSuccess
    | ILogBusinessEventFailed
    ;
